import React from "react";
import { Link } from "react-router-dom";

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className = "" }) => {
  const currentYear = new Date().getFullYear();

  const colors = {
    primary: "#D3952D",
    primaryDark: "#BB7806",
    secondary: "#212121",
    color1: "#424242",
    color2: "#757575",
    color3: "#BDBDBD",
  };

  return (
    <footer
      className={`py-2 px-4 ${className}`}
      style={{
        backgroundColor: colors.secondary,
        borderTop: `1px solid ${colors.color1}`,
      }}
    >
      {/* Copyright */}
      <div
        className="text-xs sm:text-sm text-center"
        style={{ color: "white" }}
      >
        Copyright  © {currentYear}{" "}
        <Link
          to="/"
          className="rounded-md duration-30 text-primary hover:bg-primaryHover font-medium"
        >
          Steel Plant and Machinery.
        </Link>{" "}
        All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
